export interface SpinnerProps {
  /** Accessible label announced to assistive technology. */
  label?: string;
}

/** Indeterminate loading indicator with an accessible status role. */
export function Spinner({ label = 'Loading…' }: SpinnerProps) {
  return (
    <span className="zs-spinner" role="status" aria-live="polite">
      <span className="zs-spinner__dot" aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
